import React from 'react';
import { Accordion } from '@trussworks/react-uswds';

export function USWDSAccordion(props) {
  return <Accordion {...props} />;
}
